export default {
    WITHIN_FIVE: '5',
    WITHIN_TWENTY: '20',
    TWENTY_PLUS: '20-plus',
};
